import { createSlice } from '@reduxjs/toolkit'
import { getMyBetsRoulette, placedBetRouletteGame } from 'redux-store/thunk/rouletteGame.thunk'
import { getWinningBetTypes } from '../../../games/fast-games/RouletteGame/game-helpers/index'
import { DEFAULT_PAGE_CALLS } from '../../../games/fast-games/RouletteGame/rouletteGame.constants'

const initialState = {
  placedBetData: null,
  betLock: false,
  betLoading: false,
  betWinAmt: null,
  myBetsData: {
    page: 0,
    bets: [],
    totalPages: 0
  },
  myBetsLoading: false,
  showWin: false,
  recentWinning: [],
  winTypesContent: null
}

const {
  actions: {
    setBetLock,
    setRouletteRoundEnd,
    appendMyBetsRoulette,
    setBetWinAmt,
    setShowWin
  },
  reducer
} = createSlice({
  name: 'rouletteGame',
  initialState,
  reducers: {
    setBetLock: (state, action) => {
      return {
        ...state,
        betLock: false
      }
    },
    setRouletteRoundEnd: (state, action) => {
      return {
        ...state,
        showWin: true,
        betLock: false,
        recentWinning: [state.placedBetData, ...state.recentWinning].slice(0, 4)
      }
    },
    appendMyBetsRoulette: (state, action) => {
      const data = { ...state.placedBetData }
      if (state.placedBetData) {
        const myBetsDataRows = [data, ...state.myBetsData?.bets].slice(0, 10)
        if (myBetsDataRows.length > DEFAULT_PAGE_CALLS) {
          myBetsDataRows.pop()
        }
        return {
          ...state,
          myBetsData: {
            ...state.myBetsData,
            bets: myBetsDataRows
          }
        }
      }
      return state
    },
    setBetWinAmt: (state, action) => ({
      ...state,
      betWinAmt: action.payload || null
    }),
    setShowWin: (state, action) => ({
      ...state,
      showWin: action.payload
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(placedBetRouletteGame.pending, (state, action) => {
        return {
          ...state,
          showWin: false,
          betLock: true,
          betLoading: true,
          winTypesContent: null
        }
      })
      .addCase(placedBetRouletteGame.fulfilled, (state, action) => {
        const { winningNumber } = action.payload?.bet || { winningNumber: 0 }

        const winTypesContent = getWinningBetTypes(winningNumber)

        return {
          ...state,
          winTypesContent,
          placedBetData: action.payload?.bet,
          betLoading: false
        }
      })
      .addCase(placedBetRouletteGame.rejected, (state, action) => {
        return {
          ...state,
          betLock: false,
          betLoading: false
        }
      })
      .addCase(getMyBetsRoulette.pending, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: true

        }
      })
      .addCase(getMyBetsRoulette.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false

        }
      })
      .addCase(getMyBetsRoulette.rejected, (state, action) => {
        return {
          ...state,
          myBetsLoading: false

        }
      })
  }
})

export {
  setBetLock,
  setRouletteRoundEnd,
  appendMyBetsRoulette,
  setBetWinAmt, setShowWin
}

export default reducer
